import { FormGroup } from '@angular/forms';
import { IValidator } from '../../forms/utils/validators/IValidator';
import { ILocale } from '../date/config/locale';
import { IDescriptionLabels } from '../form-field/components/field-description/field-description.component';
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

export enum FieldSpecsLayout {
    block = 'block',
    inline = 'inline',
}

/**
 * BEWARE: DO-NOT ADD field-specific configuration in this interface
 * All properties must be applicable to all types of field
 * If you need a specific field, just declare a new @Input on your component
 */
export interface IFieldSpecs {
    isDisplayed?: boolean;
    type?: string;
    formGroup: FormGroup;
    formControlName: string;
    /** CSS class name. */
    className?: string;
    placeholder?: string;
    icon?: string;
    label?: string;
    labelIcon?: string;
    iconDefinition?: IconDefinition;
    validators?: IValidator[];
    description?: IDescriptionLabels;
    title?: string;
    tabindex?: number;
    disabled?: boolean;
    layout?: FieldSpecsLayout;
    withGreyLabel?: boolean;
    withAsteriskIfRequired?: boolean;
    errorMessage?: string;
}

export interface IDateFieldSpecs extends IFieldSpecs {
    locale?: ILocale;
    minDate?: Date;
    maxDate?: Date;
    defaultDate?: Date;
    appendTo?: any;
    yearRange?: {
        min: number;
        max: number;
    };
    forceYearInPast?: boolean;
}

export interface ISliderFieldSpecs extends IFieldSpecs {
    min?: number;
    max?: number;
    range?: boolean;
    availableValues?: number[] | string[];
}

export interface ICheckboxFieldSpecs extends IFieldSpecs {
    checkboxLabel?: string;
    disableRipple?: boolean;
}
